import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const API_PROJECT_URL = '/api/qntcal';

export interface Project {
  uuid: string;
  createdBy: string;
  projectName: string;
  createdUser: string;
  customerName: string;
  createdAt?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectQntService {
  constructor(private http: HttpClient) {}

  // Create a new project
  createProject(project: Partial<Project>): Observable<any> {
    return this.http.post(`${API_PROJECT_URL}/createProjectQntCal`, project);
  }

  // Get the list of all projects
  getProjects(): Observable<Project[]> {
    return this.http.get<Project[]>(`${API_PROJECT_URL}/get-projects`);
  }

  // Delete a project
  deleteProject(id: string): Observable<any> {
    return this.http.delete(`${API_PROJECT_URL}/delete-project/${id}`);
  }

  // Update a project
  updateProject(project: Project): Observable<Project> {
    return this.http.put<Project>(`${API_PROJECT_URL}/update-project/${project.uuid}`, project);
  }

  // Get a project by UUID
  getProjectByUuid(uuid: string): Observable<Project> {
    return this.http.get<Project>(`${API_PROJECT_URL}/get-project/${uuid}`);
  }
}